export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 16C0 5.827 7.16 0 16 0s16 5.827 16 16v2.667a.4.4 0 01-.373-.32 4.92 4.92 0 00-4.96-3.68 4.92 4.92 0 00-4.96 3.68.374.374 0 01-.747 0 4.92 4.92 0 00-4.96-3.68 4.92 4.92 0 00-4.96 3.68.374.374 0 01-.747 0 4.92 4.92 0 00-4.96-3.68A4.893 4.893 0 00.387 18.36a.4.4 0 01-.387.307V16zm8.895 14.438A5.333 5.333 0 0018 26.667v-7.334a2 2 0 00-4 0v7.334a1.334 1.334 0 01-2.667 0v-1.334a2 2 0 00-4 0v1.334c0 1.414.562 2.77 1.562 3.77z\" fill=\"#A4A9B6\"/>",
  "attrs": {
    "width": "32",
    "height": "32",
    "viewBox": "0 0 32 32",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};